import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  playCourseIntroductionVideo: {
    id: 'category.course-about.course-intro.course-media.play-course-introduction-video',
    defaultMessage: 'Play course introduction video',
    description: 'The text for the button to play the course introduction video.',
  },
  watchIntroBtn: {
    id: 'category.course-about.course-intro.course-media.watch-intro-btn',
    defaultMessage: 'Watch intro',
    description: 'The visible label on the badge over the course image for courses with an introduction video.',
  },
});

export default messages;
